import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import { SignalrService } from 'src/app/Service/signalr.service';
import { Subject, takeUntil } from 'rxjs';
import { ISubUser } from 'src/app/shared/models/signalR-model';
import axios from 'src/app/Service/axiosHub';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-online-users',
  templateUrl: './online-users.component.html',
  styleUrls: ['./online-users.component.css']
})

export class OnlineUsersComponent implements OnInit {

  isHubConnect: boolean = false;
  onlineUsers: any = [];
  selectedUsers: any = [];

  mdl_Search: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    lstiSystemUser: new FormControl([]),

  });

  private destroy$ = new Subject<void>();
  private onlineUsersMap = new Map<string | number, ISubUser>();

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private _signalRService: SignalrService,
  ) {

  }

  ngOnInit(): void {

    if (!this._baseUrlHub) {
      this._tooltip.showError('این صفحه هم‌اکنون در دسترس نمی‌باشد.')
      this._router.navigateByUrl('/')
      return;
    }

    this.getOnlineUsers();

    this._signalRService.isHubConnected$.pipe(takeUntil(this.destroy$)).subscribe((isConnect: boolean) => {

      this.isHubConnect = isConnect;

      this.handleConnectionStatus(isConnect);

    });

    this.registerHubListeners();

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get _baseUrlHub(): string {
    return environment.baseUrlHub ?? '';
  }

  private registerHubListeners() {

    this._signalRService.subUserConnected$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {

      const user = JSON.parse(data.toString()) as ISubUser;

      if (!this.onlineUsersMap.has(user.iSystemUser)) {

        this.onlineUsersMap.set(user.iSystemUser, user);

        this.onlineUsers.push(user)

      }

    });

    this._signalRService.subUserDisconnected$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {

      const user = JSON.parse(data.toString()) as ISubUser;

      if (this.onlineUsersMap.has(user.iSystemUser)) {

        this.onlineUsersMap.delete(user.iSystemUser);

      }

    });

  }

  private handleConnectionStatus(connected: boolean) {

    if (!connected) {
      const host = document.querySelector('app-online-users');
      const mainElement = host?.querySelector('main') as HTMLElement;
      const overlay = document.createElement('div');

      overlay.id = 'connection-overlay';
      overlay.style.position = 'absolute';
      overlay.style.inset = '0';
      overlay.style.background = 'white';
      overlay.style.display = 'flex';
      overlay.style.alignItems = 'center';
      overlay.style.justifyContent = 'center';

      overlay.innerHTML = `
        <div class="text-center p-3 p-md-0">
          <h1 class="mb-1"><i class="fa fa-plug fa-lg text-danger"></i></h1>
          <h2 class="mb-3">متصل نیستید!</h2>
          <p class="mb-1">ارتباط با هاب سامانه قطع شده است. در صورت قطع بودن اینترنت، لطفاً اتصال خود را بررسی کنید.</p>
          <p class="mb-3">  سامانه به‌صورت خودکار در حال تلاش برای اتصال مجدد است. اگر تا ۳۰ ثانیه آینده اتصال برقرار نشد، به صفحه اصلی بازگردید.</p>
          <button class="btn btn-secondary" onclick="window.location.href='/'">بازگشت به صفحه اصلی</button>
        </div>
      `;

      mainElement.style.position = 'relative';
      mainElement.appendChild(overlay);

    }

    else {
      const overlay = document.getElementById('connection-overlay');
      overlay?.remove();
    }

  }

  getOnlineUsers = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = ((await axios.post(`Hub_OnlineUsers`, this._other.stringNumberToNumber(model))).data);

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.onlineUsers = res;

    this.onlineUsersMap = new Map(

      res.map((user: ISubUser) => [user.iSystemUser, user])

    );

  }

  get onlineUsersArray(): ISubUser[] {
    return Array.from(this.onlineUsersMap.values());
  }

  filter_Result(value: string) {

    const search = value?.trim().toLowerCase() || '';

    if (!search) {

      this.onlineUsersMap = new Map(this.onlineUsers.map((user: ISubUser) => [user.iSystemUser, user]));

      return;

    }

    this.onlineUsersMap = new Map(

      this.onlineUsers.filter((user: ISubUser) =>

        user.strFullName.toLowerCase().includes(search) ||

        user.strMobileDomain_strComment.toLowerCase().includes(search)

      ).map((user: ISubUser) => [user.iSystemUser, user])

    );

  }

  selectAllCheckBox() {

    if (this.onlineUsers.length > 0 && (this.onlineUsers.length != this.selectedUsers.length)) {

      this.selectedUsers = [];

      this.onlineUsers.forEach((a: any) => {

        this.selectedUsers.push(a.iSystemUser);

      })

      this._tooltip.showSuccess('همه انتخاب شدند')

    }

    else {

      this.selectedUsers = [];

    }

  }

  isSelected(iSystemUser: any): boolean {

    return this.selectedUsers?.indexOf(iSystemUser) !== -1;

  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.selectedUsers.push(item.iSystemUser);

    else {

      this.selectedUsers.find((value: any) => {

        if (value === item.iSystemUser) {

          const index = this.selectedUsers.indexOf(item.iSystemUser);

          if (index !== -1) this.selectedUsers.splice(index, 1);

        }

      })

    }

  }

  async exitAllCars() {

    if (!this.selectedUsers.length) return this._tooltip.showError('حداقل یک کاربر را انتخاب کنید')

    $.confirm({

      title: '',

      content: `با تایید این عملیات، تمامی کاربران به صورت فوری از سیستم خارج خواهند شد. آیا مطمئن هستید که می‌خواهید ادامه دهید؟`,

      type: 'red',

      buttons: {

        cancel: {

          text: "انصراف",

          btnClass: 'btn-outline-secondary',

        },

        ok: {

          text: "تایید",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this.mdl_Search.patchValue({

              lstiSystemUser: this.selectedUsers

            })

            let model = this.mdl_Search.value;

            this._other.Showspinner();

            let res = ((await axios.post(`Hub_ForceSignOut`, this._other.stringNumberToNumber(model))).data);

            this._other.nonespinner();

            if (res.ISSessionExpired == true) {

              this._tooltip.showError('لطفا وارد سیستم شوید');

              this._other.removeLocalStorage();

              this._router.navigate(['login'], { queryParams: { error: 'x12zss1110' } });

              return;

            };

            if (res.iResult == 0) {

              return this._tooltip.showError(res.strError);

            };

            this._tooltip.showSuccess('همه کارربران از سیستم خارج شدند')

            this.getOnlineUsers();

          }

        },

      }

    });

  }

}
